import { computed, ref } from 'vue';
import { createSharedComposable } from '@vueuse/core';
import { TOASTER_TIMEOUT, ToasterVariant } from '../components/Toaster/consts';

const useToaster = () => {
  const _title = ref('');
  const _isOpen = ref(false);
  const _variant = ref(ToasterVariant.INFO);
  const _setTimeoutIdRef = ref<ReturnType<typeof setTimeout> | null>(null);

  const showToaster = (text: string, variant = ToasterVariant.INFO) => {
    if (_setTimeoutIdRef.value) {
      clearTimeout(_setTimeoutIdRef.value);
    }
    _title.value = text;
    _variant.value = variant;
    _isOpen.value = true;
    _setTimeoutIdRef.value = setTimeout(closeToaster, TOASTER_TIMEOUT);
  };

  const closeToaster = () => {
    if (_setTimeoutIdRef.value) {
      clearTimeout(_setTimeoutIdRef.value);
    }
    _isOpen.value = false;
    _setTimeoutIdRef.value = null;
  };

  // create read only with computed values
  const title = computed(() => _title.value);
  const isToasterOpen = computed(() => _isOpen.value);
  const toasterVariant = computed(() => _variant.value);

  return { showToaster, title, isToasterOpen, toasterVariant, closeToaster };
};
export default createSharedComposable(useToaster);
